/**
 * This copies the input string to clipboard
 * @param str
 */
export default str => {
  const el = document.createElement('textarea')
  el.className = 'copy-to-clipboard-textarea'
  el.value = str
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}
